import React from 'react';

import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import newsletter from '@app/images/content/lap-of-love-newsletter.jpg';
import '@app/scss/components/newsletter.scss';

const Newsletter: React.FC = () => {
	const url = 'https://info.lapoflove.com/en/senior-pet-digest-subscription-page';

	const content = (
		<>
			Senior Pet Digest is Lap of Love’s monthly e-newsletter that delivers helpful articles directly to your inbox. Whether you are struggling
			with your pet’s recent medical diagnosis, have questions about euthanasia, or are looking for helpful tips to keep your senior pet healthy
			and happy, our newsletter will provide valuable insight. Each issue contains articles and resources related to senior pet care, common pet
			diseases, in-home euthanasia, end-of-life care, and pet loss support that will help you better care for your beloved companion.
			{' '}
			<a href={url} target="_blank" rel="noopener noreferrer">
				Subscribe here
			</a>
			{' '}
			to ensure you don’t miss out on this helpful resource.
		</>
	);

	const openInNewTab = (arg) => {
		const win = window.open(arg, '_blank');
		win && win.focus();
	};

	return (
		<HelmetProvider>
			<div className="newsletter">
				<Masthead
					title="Senior Pet Digest Newsletter"
					imageSrc={newsletter}
					buttonText="Subscribe"
					btnPath={url}
					onBtnClick={openInNewTab}
					to="/newsletter"
					imageAlt="Lap of Love newsletter"
				/>
				<RichText title="What is the Senior Pet Digest?" text={content} />
			</div>
		</HelmetProvider>
	);
};

export default Newsletter;
